import {
  MARIN_ROUTES,
  SETTINGS_ROUTES
} from "@gettactic/defines/src/web-routes";
import { buildUrl, canScheduleOthers, isBillingVisible } from "@gettactic/helpers";

import type { MenuItem } from "./types";

export const NAV_USER_CLASS_NAMES = {
  menuItem:
    "cursor-pointer hover:rounded-none active:rounded-none transition-none",
  menuItemHiddenOnMobile: "hidden md:block"
};

export const MENU_ITEMS: MenuItem[] = [
  {
    id: "settings",
    titleKey: "settings",
    href: buildUrl(SETTINGS_ROUTES.profile),
    enabled: () => true,
    showOnMobile: false
  },
  {
    id: "admin",
    titleKey: "admin",
    href: buildUrl(MARIN_ROUTES.admin),
    enabled: (user) => canScheduleOthers(user),
    showOnMobile: false
  },
  {
    id: "chatSupport",
    titleKey: "chatSupport",
    href: null,
    enabled: () => true,
    showOnMobile: false,
    isAction: true
  },
  {
    id: "billing",
    titleKey: "billing",
    href: null,
    enabled: (user) => isBillingVisible(user),
    showOnMobile: false,
    isAction: true
  },
  {
    id: "helpCenter",
    titleKey: "helpCenter",
    href: "https://help.gettactic.com/hc/en-us",
    enabled: () => true,
    showOnMobile: false
  }
];
